window.recaptchaCallback = function () {
    let forms = document.querySelectorAll("form");
    forms.forEach(function (form) {
        let recaptcha = form.querySelector(".google-recaptcha");
        if (recaptcha) {
            const widgetId = grecaptcha.render(recaptcha, {
                sitekey: recaptcha.getAttribute("data-sitekey"),
            });

            form.dataset.recaptchaWidgetId = widgetId;

            form.addEventListener("submit", function (e) {
                const widgetId = form.dataset.recaptchaWidgetId;
                const token = grecaptcha.getResponse(widgetId);

                let border = recaptcha.querySelector("iframe");
                if (!token) {
                    e.preventDefault();
                    border.classList.add("recaptcha-warn");
                } else {
                    border.classList.remove("recaptcha-warn");
                }
            });
        }
    });
};

function mobileSectionNav() {
    const nav = document.getElementById('mobile-section-nav');
    if (!nav) return;

    const pills = nav.querySelectorAll('.mobile-section-pill');
    let isUserScrolling = false;
    let scrollTimeout;

    // Helper function to set active pill
    function setActivePill(activePill) {
        pills.forEach(pill => {
            const isActive = pill === activePill;

            // Remove all state classes first
            pill.classList.remove('bg-white', 'text-darkgrey', 'bg-gradient-to-r', 'from-[#ea3f47]', 'via-[#f0672f]', 'to-[#f89e0e]', 'text-white', 'font-medium', 'font-normal', 'active-pill');

            // Apply appropriate classes
            if (isActive) {
                pill.classList.add('bg-gradient-to-r', 'from-[#ea3f47]', 'via-[#f0672f]', 'to-[#f89e0e]', 'text-white', 'font-medium', 'active-pill');
            } else {
                pill.classList.add('bg-white', 'text-darkgrey', 'font-normal');
            }
        });

        // Scroll the active pill into view within the nav
        if (activePill) {
            activePill.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }

    // Calculate scroll offset based on sticky header and nav height
    function getScrollOffset() {
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;
        const navHeight = nav ? nav.offsetHeight : 0;
        return headerHeight + navHeight + 20; // Add small buffer
    }

    // Smooth scroll to section with proper offset
    function scrollToSection(sectionId) {
        const target = document.getElementById(sectionId);
        if (!target) return;

        const offset = getScrollOffset();
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }

    pills.forEach(pill => {
        pill.addEventListener('click', (e) => {
            e.preventDefault();

            // Set flag to prevent observer from interfering
            isUserScrolling = true;

            // Set active state immediately on click
            setActivePill(pill);

            // Scroll to section with proper offset
            scrollToSection(pill.dataset.section);

            // Reset flag after scroll completes
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                isUserScrolling = false;
            }, 1000);
        });
    });

    // Scroll-spy
    const sections = Array.from(pills).map(pill => document.getElementById(pill.dataset.section)).filter(Boolean);

    // Track which sections are currently intersecting
    const intersectingEntries = new Map();

    const observer = new IntersectionObserver((entries) => {
        // Don't update during user-initiated scrolling
        if (isUserScrolling) return;

        // Update the map with latest intersection states
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                intersectingEntries.set(entry.target.id, entry.intersectionRatio);
            } else {
                intersectingEntries.delete(entry.target.id);
            }
        });

        // Find the most visible section
        if (intersectingEntries.size > 0) {
            let mostVisibleSection = null;
            let highestRatio = 0;

            intersectingEntries.forEach((ratio, sectionId) => {
                if (ratio > highestRatio) {
                    highestRatio = ratio;
                    mostVisibleSection = sectionId;
                }
            });

            // Set the corresponding pill as active
            if (mostVisibleSection) {
                const activePill = Array.from(pills).find(pill => pill.dataset.section === mostVisibleSection);
                if (activePill) {
                    setActivePill(activePill);
                }
            }
        }
    }, {
        rootMargin: '-180px 0px -40% 0px',
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
    });

    sections.forEach(section => observer.observe(section));
}

mobileSectionNav();

function smoothAnchorLinks() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
            const href = anchor.getAttribute('href');
            if (href === '#') return;
            const target = document.querySelector(href);
            if (!target) return;
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    });
}

smoothAnchorLinks();


// recaptcha required

const forms = Array.from(document.querySelectorAll("form")).filter((form) => form.querySelector(".google-recaptcha"));

forms.forEach(function (form) {
    form.addEventListener("submit", function (e) {
        var response = grecaptcha.getResponse();
        if (response.length === 0) {
            e.preventDefault();
            alert("Please verify that you are not a robot.");
        }
    });
});